import api from '@/services/api'

export default {
    fetchOrders({params, token}) {
        return api.get(`orders/`,  {params, cancelToken: token})
            .then(response => response.data)
    },
    fetchSharedOrders(params) {
        return api.get(`orders/shared/`,  {params})
            .then(response => response.data)
    },
    fetchFilteredOrders({params, token}) {
        return api.get(`orders/filtered/`,  {params, cancelToken: token})
            .then(response => response.data)
    },
    getOrder(order_id) {
        return api.get(`orders/${order_id}/`)
            .then(response => response.data)
    },
    postOrder(payload) {
        return api.postForm(`orders/`, payload)
            .then(response => response.data)
    },
    editOrder(order) {
        return api.put(`orders/${order.id}/`, order)
            .then(response => response.data)
    },
    deleteOrder(order_id) {
        return api.delete(`orders/${order_id}/`)
            .then(response => response.data)
    },
    togglePaid({data, order_id}) {
        return api.putForm(`orders/${order_id}/toggle_paid/`, data)
            .then(response => response.data)
    },
    toggleService({service_id, action_place, order_id}) {
        return api.put(`orders/${order_id}/toggle_service/`, {service_id, action_place})
            .then(response => response.data)
    },
    toggleReturnValue({value, action_place, order_id}) {
        return api.put(`orders/${order_id}/toggle_return_value/`, {value, action_place})
            .then(response => response.data)
    },
    toggleCollected(data) {
        return api.put(`orders/${data.order_id}/toggle_collected/`, data)
            .then(response => response.data)
    },
    setState(data) {
        return api.put(`orders/${data.order.id}/set_state/`, data)
            .then(response => response.data)
    },
    moveOrders(data) {
        return api.post(`orders/move_orders/`, data)
            .then(response => response.data)
    }
}